export default __webpack_public_path__ + "static/media/carousel-arrow-right.da596b0b.svg";